import { useState } from 'react';
import { cn } from '@/lib/utils';
import { config } from '@/config/env.config';

export interface UserAvatarProps {
  /** Usuário com email, fullName e opcionalmente avatarUrl (ou avatar_url da API) */
  user: {
    id: string;
    email: string;
    fullName?: string | null;
    avatarUrl?: string | null;
    avatar_url?: string | null;
  };
  size?: 'sm' | 'md';
  className?: string;
}

const sizeClasses = {
  sm: 'w-6 h-6 text-xs',
  md: 'w-8 h-8 text-xs',
};

function resolveAvatarUrl(raw: string | null | undefined): string | null {
  const url = (raw ?? '').trim();
  if (!url) return null;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  const base = config.api.baseUrl.replace(/\/$/, '');
  return url.startsWith('/') ? `${base}${url}` : `${base}/${url}`;
}

export function UserAvatar({ user, size = 'md', className }: UserAvatarProps) {
  const rawUrl = user.avatarUrl ?? user.avatar_url;
  const avatarUrl = resolveAvatarUrl(rawUrl ?? null);
  const [imageFailed, setImageFailed] = useState(false);

  const initials = user.fullName
    ? user.fullName
        .split(' ')
        .map((n) => n[0])
        .join('')
        .substring(0, 2)
        .toUpperCase()
    : (user.email || '?').substring(0, 2).toUpperCase();

  const showImage = avatarUrl && !imageFailed;

  if (showImage) {
    return (
      <img
        src={avatarUrl}
        alt=""
        className={cn(
          'rounded-full object-cover shrink-0',
          sizeClasses[size],
          className,
        )}
        onError={() => setImageFailed(true)}
      />
    );
  }

  return (
    <div
      className={cn(
        'rounded-full bg-primary/10 flex items-center justify-center font-semibold shrink-0',
        sizeClasses[size],
        className,
      )}
    >
      {initials}
    </div>
  );
}
